import React, { useEffect, useState } from 'react'
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';

const ChipInput = ({name, label, register, setValue, getValues, placeholder, errors}) => {
    const [chips, setChips] = useState([]);
    const {editCourse, course} = useSelector((state) => state.course);

    useEffect(() => {
        if(editCourse){
            setChips(course?.tag);
        }

        register(name,{
            required: true,
            validate: (value) => value.length > 0
        })
    },[]);

    useEffect(() => {
        setValue(name, chips);
    },[chips])

    const handleKeyDown = (event) => {
        if(event.key === 'Enter' || event.key === ','){
            event.preventDefault();
            const chipsValue = event.target.value.trim();

            if(chipsValue && !chips.includes(chipsValue)){
                const newChips = [...chips, chipsValue];
                setChips(newChips);
                event.target.value = ""
            }
        }
    }    

    const handleDeleteChip = (chipIndex) => {
        const newChips = chips.filter((_, index) => index !== chipIndex)
        setChips(newChips);
    }
  return (
    <div className="flex flex-col space-y-2">
      {/* Render the label for the input */}
      <label className="text-sm text-richblack-5" htmlFor={name}>
        {label} <sup className="text-pink-200">*</sup>
      </label>
      {/* Render the chips and input */}
      <div className="flex w-full flex-wrap gap-y-2">
        {/* Map over the chips array and render each chip */}
        {chips.map((chip, index) => (
          <div
            key={index}
            className="m-1 flex items-center rounded-full bg-yellow-400 px-2 py-1 text-sm text-richblack-5"
          >
            {/* Render the chip value */}
            {chip}
            {/* Render the button to delete the chip */}
            <button
              type="button"
              className="ml-2 focus:outline-none"
              onClick={() => handleDeleteChip(index)}
            >
              <IoMdClose className="text-sm" />
            </button>
          </div>
        ))}
        {/* Render the input for adding new chips */}
        <input
          id={name}
          name={name}
          type="text"
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          className="form-style w-full"
        />
      </div>
      {/* Render an error message if the input is required and not filled */}
      {errors[name] && (
        <span className="ml-2 text-xs tracking-wide text-pink-200">
          {label} is required
        </span>
      )}
    </div>
  )
}

export default ChipInput